<template>
  <div>
    <el-form :inline="true" :model="filters">
      <!-- <el-form-item label="产品类型">
        <productTypeSelector ref="productTypeSelector" v-model="filters.productType" />
      </el-form-item>
      <el-form-item label="产品系列">
        <productSetSelector ref="productSetSelector" v-model="filters.productSet" />
      </el-form-item> -->
      <el-form-item>
        <el-input size="small" v-model="filters.search" placeholder="请输入关键词搜索"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="queryAll">查询</el-button>
        <el-button size="small" type="success" icon="el-icon-plus" @click="handleCreate">添加</el-button>
      </el-form-item>
    </el-form>
    <div class="tab-content">
      <!-- 列表 -->
      <el-table size="mini" stripe border :data="tableData" highlight-current-row expand-on-click-node="false"
        style="width: 100%">
        <el-table-column prop="Code" label="产品代码" width="120"></el-table-column>
        <el-table-column prop="Name" label="产品名称" width="100"></el-table-column>
        <el-table-column prop="ProductType.Name" label="产品类型" width="100"></el-table-column>
        <el-table-column prop="ProductSet.Name" label="产品系列" width="100"></el-table-column>
        <el-table-column prop="Specical" label="产品规格" width="100"></el-table-column>
        <el-table-column prop="SalePrice" label="价格与质保" min-width="100">
          <template slot-scope="scope">
            <el-tag type="info">售价￥：{{ scope.row.SalePrice }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" align="center">
          <template slot-scope="scope">
            <el-button-group>
              <el-button type="primary" icon="el-icon-edit" size="small" @click="handleUpdate(scope.row)">修改</el-button>
              <el-button type="danger" icon="el-icon-delete" size="small"
                @click="handleDelete(scope.$index, scope.row)">删除</el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :page-sizes="pageSizesList" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total" :current-page.sync="pageIndex"></el-pagination>
      </div>
    </div>
    <!-- 新增框 -->
    <div v-if="formVisible">
      <el-dialog v-dragDialog :title="formTitle" :visible.sync="formVisible" width="1000px" :close-on-click-modal="false">
        <el-form :model="dataForm" ref="dataForm" label-width="150px" :rules="formRules">
          <el-row>
            <el-col :span="12">
              <el-form-item label="产品代码：" prop="Code">
                <el-input v-model="dataForm.Code" auto-complete="off" placeholder="请输入产品代码"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="产品名称：" prop="Name">
                <el-input v-model="dataForm.Name" auto-complete="off" placeholder="请输入产品名称"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="产品类型：" prop="ProductType">
                <!-- <productTypeSelector ref="productTypeSelector" v-model="dataForm.ProductType" /> -->
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="产品系列:" prop="ProductSet">
                <!-- <productSetSelector ref="productSetSelector" v-model="dataForm.ProductSet" /> -->
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="产品规格:" prop="Specical">
                <el-input v-model="dataForm.Specical" auto-complete="off" placeholder="请输入产品规格"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="太阳能阻隔率%：" prop="TaiYangNengRate">
                <el-input-number v-model.number="dataForm.TaiYangNengRate" style="width:100%;" auto-complete="off"
                  placeholder="请输入太阳能总阻隔率"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="可见光透射比%：" prop="TouSheRate">
                <el-input-number v-model="dataForm.TouSheRate" style="width:100%;" auto-complete="off"
                  placeholder="请输入可见光透射比"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="可见光反射比%：" prop="FanSheRate">
                <el-input-number v-model="dataForm.FanSheRate" style="width:100%;" auto-complete="off"
                  placeholder="请输入可见光反射比"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="紫外线阻隔率%：" prop="ZiWaiXianRate">
                <el-input-number v-model="dataForm.ZiWaiXianRate" style="width:100%;" auto-complete="off"
                  placeholder="请输入紫外线阻隔率"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="红外线阻隔率%：" prop="Mil">
                <el-input-number v-model.number="dataForm.HongWaiXianRate" style="width:100%;" auto-complete="off"
                  placeholder="请输入红外线阻隔率"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="厚度Mil：" prop="Mil">
                <el-input-number v-model.number="dataForm.Mil" style="width:100%;" auto-complete="off" placeholder="请输入厚度"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="质保期(年）：" prop="WarrantyPeriod">
                <el-input-number v-model="dataForm.WarrantyPeriod" style="width:100%;" auto-complete="off"
                  placeholder="请输入质保期"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="每米市场价：" prop="SalePrice">
                <el-input-number v-model.number="dataForm.SalePrice" style="width:100%;" auto-complete="off" placeholder="请输入每米市场价"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="每卷长度：" prop="TotalLength">
                <el-input-number v-model="dataForm.TotalLength" style="width:100%;" auto-complete="off"
                  placeholder="请输入每卷长度"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="每卷可供台次：" prop="SupplyCarCount">
                <el-input-number v-model="dataForm.SupplyCarCount" auto-complete="off"
                  placeholder="请输入每卷可供台次" style="width:100%;"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="formVisible = false">取消</el-button>
          <el-button v-if="dialogStatus == 'create'" type="primary" @click="createSubmit">提交</el-button>
          <el-button v-else type="primary" @click="updateSubmit">提交</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { getPageList, save, deleteObj } from "@/api/product/products";
import productSetSelector from "@/components/productSetSelector.vue";
import productTypeSelector from "@/components/productTypeSelector.vue";
export default {
  components: {
    productSetSelector,
    productTypeSelector
  },
  data() {
    return {
      filters: {
        productType: "",
        productSet: "",
        search: "",
      },
      tableData: [],
      total: 0,
      pageIndex: 1,
      pageSize: 5,
      pageSizesList: [5, 10, 15, 20, 30, 50],

      formTitle: "",
      formVisible: false,

      dataForm: {},
      formRules: {
        Code: [{ required: true, message: "请输入产品代码", trigger: "change" }],
        Name: [{ required: true, message: "请输入产品名称", trigger: "change" }],
        ProductType: [
          { required: true, message: "请选择产品类型", trigger: "change" },
        ],
        Specical: [
          { required: true, message: "请输入产品规格", trigger: "change" },
        ],
        ProductSet: [
          { required: true, message: "请选择产品系列", trigger: "change" },
        ],
        TouSheRate: [
          { required: true, message: "请输入可见光透射比", trigger: "change" },
        ],
        FanSheRate: [
          { required: true, message: "请输入可见光反射比", trigger: "change" },
        ],
        HongWaiXianRate: [{ required: true, message: "请输入红外线阻隔率", trigger: "change" },],
        ZiWaiXianRate: [
          { required: true, message: "请输入紫外线阻隔率", trigger: "change" },
        ],
        TaiYangNengRate: [
          {
            required: true,
            message: "请输入太阳能总阻隔率",
            trigger: "change",
          },
        ],
        Mil: [{ required: true, message: "请输入厚度", trigger: "change" }],
        WarrantyPeriod: [
          { required: true, message: "请输入质保期", trigger: "change" },
        ],
        SalePrice:[{ required: true, message: "请输入每米市场价", trigger: "change" },],
        TotalLength:[{ required: true, message: "请输入每卷质长度", trigger: "change" },],
        SupplyCarCount:[{ required: true, message: "请输入每卷质保台次", trigger: "change" },]
      },
    };
  },
  methods: {
    queryAll() {
      let para = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        search: this.filters.search,
        productType: this.filters.productType ? this.filters.productType.Key : "",
        productSet: this.filters.productSet ? this.filters.productSet.Key : "",
      };
      getPageList(para).then((response) => {
        if (response) {
          this.tableData = response.Items;
          this.total = response.Total || response.Items.length;
        }
      });
    },
    handleCreate() {
      this.formTitle = "新增";
      this.dataForm = {
        ProductSet: "",
        ProductType: ""
      };
      this.formVisible = true;
    },
    createSubmit: function () {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          let para = Object.assign({}, this.dataForm);
          save(para).then((response) => {
            if (response) {
              this.formVisible = false;
              this.queryAll();
            }
          });
        }
      });
    },

    handleUpdate(row) {
      this.dataForm = Object.assign({}, row);
      this.formTitle = "修改";
      this.formVisible = true;
    },

    updateSubmit: function () {
      this.$confirm("确认提交吗？", "提示", {}).then(() => {
        let para = Object.assign({}, this.dataForm);
        save(para).then((response) => {
          if (response) {
            this.formVisible = false;
            this.queryAll();
          }
        });
      });
    },
    //删除
    handleDelete: function (index, row) {
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      }).then(() => {
        let para = { key: row.Key };
        deleteObj(para).then((response) => {
          if (response) {
            this.msg.successMsg("操作成功");
            this.queryAll();
          }
        });
      });
    },
    handleSizeChange(val) {
      var pageSize = val;
      this.pageIndex = 1;
      this.pageSize = parseInt(pageSize);
      this.$nextTick(() => this.queryAll());
    },

    handleCurrentChange(val) {
      this.pageIndex = val;
      this.queryAll();
    },
  },
  mounted() {
    //this.queryAll();
  },
};
</script>
<style lang='scss'  scoped>
/deep/.el-tabs--border-card>.el-tabs__content {
  padding: 0;
  height: 1px;
}

.tab-content {
  margin-top: -2px;
  border: 1px solid #dcdfe6;
  border-top: 0;
  padding: 15px;
  background: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
}
</style>
